import { render, staticRenderFns } from "./TablePropuestas.vue?vue&type=template&id=9d5798d4&scoped=true"
import script from "./TablePropuestas.vue?vue&type=script&lang=js"
export * from "./TablePropuestas.vue?vue&type=script&lang=js"
import style0 from "./TablePropuestas.vue?vue&type=style&index=0&id=9d5798d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5798d4",
  null
  
)

export default component.exports